import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class TypeOfIndebtednessEditService {
	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadIndebtedness(token, ID) {
		

		
		
		
		
		
		
		

		return this.http
			.get(this.apiUrl + "typeofdebt/v1/gettypeofdebt/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});

  }
    
	editIndebtedness(token, indebtedness: any) {
		

		
		
		
		
		
		
		

		return this.http
			.put(this.apiUrl + "typeofdebt/v1/updatetypeofdebt", indebtedness, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/type-of-indebtedness/service/type-of-indebtedness-edit/type-of-indebtedness-edit.service.ts